import React, { useRef, useState, useCallback, useEffect } from 'react';
import { useFrame } from '@react-three/fiber';
import { useGLTF } from '@react-three/drei';
import { useFormStore } from '../../state/FormStore';

export function GlassSlidingDoor({ verandaSize, verandaColor, opaalTexture, playTexture, nodes, materials }) {
    const { getNumberOfGlassDoors } = useFormStore();
    const formData = useFormStore(state => state.formData.voorkant.schuifdeur);

    const numberOfDoors = getNumberOfGlassDoors();

    const [doorRefs, setDoorRefs] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [targetPosition, setTargetPosition] = useState(null);

    const doorWidth = 1 / numberOfDoors * (verandaSize[0] / 10 + 1.01);
    useEffect(() => {
        // Initialize refs when numberOfDoors changes
        setDoorRefs(Array.from({ length: numberOfDoors }, () => React.createRef()));
    }, [numberOfDoors]);



    useEffect(() => {
        if (formData) {
            setIsOpen(true); // Start the animation when formData changes
            setTargetPosition(doorRefs[0]?.current?.position.x || 0); // Set target position based on the first door's position

            // Set a timeout to revert the doors back to the original position
            const timeoutId = setTimeout(() => {
                setIsOpen(false);
            }, 1500); // Adjust the delay as needed (2000ms = 2 seconds)

            return () => clearTimeout(timeoutId); // Cleanup timeout if formData changes again
        }
    }, [formData, doorRefs]); // Run this effect when formData or doorRefs change

    useFrame(() => {
        if (isOpen) {
            doorRefs.forEach((doorRef, index) => {
                if (doorRef.current) {
                    doorRef.current.position.x += (targetPosition - doorRef.current.position.x) * 0.05; // Adjust animation speed as needed
                }
            });
        } else {
            doorRefs.forEach((doorRef, index) => {
                if (doorRef.current) {
                    doorRef.current.position.x += (index * doorWidth - (numberOfDoors - 1) * doorWidth / 2 - doorRef.current.position.x) * 0.05; // Return to original position
                }
            });
        }
    });
    const handleDoorClick = useCallback((index) => {
        setIsOpen(!isOpen);
        if (!isOpen) {
            // Set target position to the position of the first door
            setTargetPosition(doorRefs[0].current.position.x);
        }
    }, [isOpen, doorRefs]);

    return (
        <group
            name="alumn_slding_door"
            scale={verandaSize}
        >


            <mesh
                castShadow
                receiveShadow
                onClick={handleDoorClick}
                geometry={nodes.play_front.geometry}>
                <meshStandardMaterial attach="material" map={playTexture} transparent opacity={1} />
            </mesh>


            <mesh
                castShadow
                receiveShadow
                geometry={nodes.gs_topframe1001.geometry}
                material={nodes.gs_topframe1001.material}
            >
                <meshStandardMaterial attach="material" color={verandaColor[0]} />
            </mesh>

            {Array.from({ length: numberOfDoors }).map((_, index) => (
                <group
                    key={index}
                    name={`glass_frame_${index}`}
                >
                    <mesh
                        castShadow
                        receiveShadow
                        geometry={nodes.gs_bottomframe.geometry}
                        material={materials['lambert1.003']}
                    />
                </group>
            ))}

            {doorRefs.map((doorRef, index) => (
                <group
                    key={index}
                    ref={doorRef}
                    onClick={() => handleDoorClick(index)}
                    position={[index * doorWidth - (numberOfDoors - 1) * doorWidth / 2, 0, index * -0.002]} // Adjust X position

                >

                    <group name="Glass_Door" scale={[doorWidth, 1, 1]}>
                        <group>
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes['GD-HAndel2-Front'].geometry}
                                material={nodes['GD-HAndel2-Front'].material}

                            />
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes['GDRound-Handel-Front'].geometry}
                                material={nodes['GDRound-Handel-Front'].material}
                            />

                        </group>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.front_glass_door_1.geometry}
                            material={nodes.front_glass_door_1.material}
                        >

                        </mesh>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.front_glass_door_2.geometry}
                            material={nodes.front_glass_door_2.material}
                        >
                            <meshStandardMaterial
                                attach="material"
                                map={opaalTexture}
                                color="#8de3c7"
                                transparent
                                opacity={0.3}
                            />
                        </mesh>
                    </group>
                </group>
            ))}
        </group>
    );
}

//useGLTF.preload('/veranda3/veranda3.glb');
